// Ícone e cor escolhidos na criação de um Agente → componentes/labels prontos para a UI.
import {
  Bot, Sparkles, MessageSquare, Code2, PenLine, Calculator, Globe, BookOpen,
  Briefcase, HeartPulse, Wand2, Brain, GraduationCap, ScrollText, Megaphone, ShieldCheck,
} from 'lucide-react';
import type { AgentColor, AgentIcon } from '../api';

export const AGENT_ICON_CMP: Record<AgentIcon, React.ComponentType<{ size?: number }>> = {
  bot: Bot, sparkles: Sparkles, 'message-square': MessageSquare, 'code-2': Code2, 'pen-line': PenLine,
  calculator: Calculator, globe: Globe, 'book-open': BookOpen, briefcase: Briefcase, 'heart-pulse': HeartPulse,
  'wand-2': Wand2, brain: Brain, 'graduation-cap': GraduationCap, 'scroll-text': ScrollText, megaphone: Megaphone, 'shield-check': ShieldCheck,
};

export const AGENT_COLOR_LABEL: Record<AgentColor, string> = { fil: 'Âmbar', cool: 'Azul', ok: 'Verde', err: 'Vermelho', violet: 'Violeta', rose: 'Rosa' };

/** Círculo colorido com o ícone do agente dentro — usado no card, no cabeçalho da conversa e na lista de agentes. */
export function AgentAvatar({ icon, color, size = 20, photo, name }: { icon: AgentIcon; color: AgentColor; size?: number; photo?: string | null; name?: string }) {
  const Icon = AGENT_ICON_CMP[icon] ?? Bot;
  const box = size * 1.8;
  // com foto, ela ocupa o lugar do ícone (a foto já foi validada como data URL de imagem no servidor)
  if (photo) return <span className="agent-avatar photo" style={{ width: box, height: box }}><img src={photo} alt={name ?? ''} /></span>;
  return <span className={`agent-avatar c-${color}`} style={{ width: box, height: box }}><Icon size={size} /></span>;
}
